import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Subject } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  private serch = new Subject();
  serchFlag = this.serch.asObservable();

  constructor(private apiService: ApiService) { }

  changeSerchFlag(flag: any) {
    this.serch.next(flag);
  }

  getSearchData(params) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONTENTS + API_ENDPOINTS.API.SEARCH + params);
  }

  getUserSearchData(searchQuery, page = 1) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USERS + API_ENDPOINTS.API.SEARCH + '?' + 'search=' + searchQuery + '&page=' + page);
  }

  addConnection(params) {
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONNECTIONS, params);
  }

  deleteConnection(userId) {
    return this.apiService.delete(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONNECTIONS + '/' + userId);
  }
  
  acceptConnection(userId, params) {
    return this.apiService.patch(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONNECTIONS + '/' + userId, params);
  }
  cancelSentRequest(connectionId) {
    return this.apiService.delete(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONNECTIONS + '/' + connectionId);
  }

  cancelSentSaRequest(id){
    return this.apiService.delete(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUPP_CONNECTIONS + '/' + id);
  }

  rejectConnection(userId, params) {
    return this.apiService.patch(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONNECTIONS + '/' + userId, params);
  }
}
